import { getSmsVerificationCode, verifySmsVerificationCode } from '@/utils/api';
import i18n from '@/utils/i18n';
import Vue from 'vue';
import router from '@/router';
import Vuex from 'vuex';
import { getField, updateField } from 'vuex-map-fields';
import moment from 'moment';
import { LoginTypes } from '@/utils/enums';

Vue.use(Vuex);

const state = {
  verificationCode: '',
  verificationCodeModel: {},
  cod_transaction: '',
  phoneNumber: '',
  currentState: 'IN_STEP1', // IN_STEP1 | IN_STEP2
  verificationCodeStatus: {
    loading: false,
    success: false,
    error: false,
  },
  verifyCompleteCodeStatus: {
    loading: false,
    success: false,
    error: false,
    verify_error: false,
  },
};

const getters = {
  getField,
};

const mutations = {
  updateField,
  setCurrentState(state, val) {
    state.currentState = val;
  },
  setVerificationCodeModel(state, val) {
    state.verificationCodeModel = val;
  },
  setVerificationCodeStatus(state, row) {
    state.verificationCodeStatus = {
      ...state.verificationCodeStatus,
      ...row,
    };
  },
  setVerifyCompleteCodeStatus(state, row) {
    state.verifyCompleteCodeStatus = {
      ...state.verifyCompleteCodeStatus,
      ...row,
    };
  },
  resetCounter() {
    state.counterTick = TOTAL_SMS_CODE_TIMER;
  },
  decreaseCounterTick(state) {
    state.counterTick -= 1;
  },
  setCod_transaction(state, data) {
    state.cod_transaction = data;
  },
};

const actions = {
  tryGetACode({ commit, rootState, dispatch }, phoneNumber) {
    commit('setVerificationCodeStatus', { loading: true });
    commit('setVerifyCompleteCodeStatus', {
      verify_error: false,
      loading: false,
      success: false,
      error: false,
    });
    getSmsVerificationCode(phoneNumber).then(r => {
      if (r.data.IsSuccess) {
        const verifyCodeResult = r.data.Data;
        if (verifyCodeResult.success && verifyCodeResult.data.sms_send) {
          commit('setVerificationCodeModel', verifyCodeResult);
          commit('setCurrentState', 'IN_STEP2');
          commit('setVerificationCodeStatus', { success: true, error: false });
          // dispatch("resetCounter");
          // dispatch("startCounter");
        } else {
          commit('setVerificationCodeStatus', {
            success: false,
            error: i18n.t('Exceptions.VerifyCode.' + verifyCodeResult.message),
          });
        }
      }
      commit('setVerificationCodeStatus', { loading: false });
    });
  },
  tryVerifyCode({ commit, rootState, dispatch }, formData) {
    commit('setVerificationCodeStatus', { loading: true });
    commit('setVerifyCompleteCodeStatus', {
      verify_error: false,
      loading: true,
      success: false,
      error: false,
    });

    verifySmsVerificationCode(formData).then(r => {
      if (r.data.IsSuccess) {
        const verifyCodeResult = r.data.Data;
        if (verifyCodeResult.success && verifyCodeResult.data.verified === true) {
          commit('setVerificationCodeStatus', { success: true, error: false });
          commit('setVerifyCompleteCodeStatus', {
            loading: false,
            success: true,
            error: false,
            verify_error: false,
          });
          dispatch('accountVerificationStore/tryGetAccountVerificationStatus', null, { root: true });
          commit('authStore/setSmsVerificationRequested', '', { root: true });
          location.reload();
        } else {
          commit('setVerificationCodeStatus', {
            success: false,
            error: i18n.t('Exceptions.VerifyCode.' + verifyCodeResult.message),
          });
          commit('setVerifyCompleteCodeStatus', {
            loading: false,
            success: false,
            error: true,
            verify_error: true,
          });
        }
      } else {
        commit('setVerifyCompleteCodeStatus', {
          loading: false,
          success: false,
          error: true,
          verify_error: true,
        });
      }
      commit('setVerificationCodeStatus', { loading: false });
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
